import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { tenantsCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';
import { getAllTenants } from '../../../store/actions';
import EditIcon from './EditIcon';
import ToggleButton from '../../utility/ToggleButton';

export class Tenants extends React.Component {
  _isMounted = false;

  borderBottomSecondary = {
    borderBottom: `4px solid ${this.props.tenant.secondary}`,
  };

  buttonContainerStyle = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  disabledButtonContainerStyle = {
    backgroundColor: 'white',
  };

  borderBottom = {
    borderBottom: `4px solid ${this.props.tenant.secondary}`,
  };

  render() {
    const { tenant } = this.props;
    return (
      <div className="tenant-bar" style={this.borderBottom}>
        <div className="tenant-bar__left-side">
          <div
            role="button"
            className="tenant-bar__edit-button"
            tabIndex={0}
            onClick={() => {
              this.props.openTenantModal('Edit', tenant.id);
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key))
                this.props.openTenantModal('Edit', tenant.id);
            }}
          >
            <EditIcon color={tenant.primary} />
            <span className="tenant-bar__edit-text">{copy.editButton}</span>
          </div>
          <h2 className="tenant-bar__name">{tenant.name}</h2>
        </div>
        <div className="tenant-bar__right-side">
          <p className="tenant-bar__published">{copy.published}</p>
          <ToggleButton
            className={classNames({
              'toggle-button-modality': true,
            })}
            value={this.props.tenant.published}
            color="white"
            onClick={() => {
              this.props.updatePublishedAndRefresh(this.props.tenant.id);
            }}
            backgroundStyle={
              this.props.tenant.published
                ? this.buttonContainerStyle
                : this.disabledButtonContainerStyle
            }
            buttonContainerStyle="toggle-button"
            ariaLabel="Turn on to publish tenant. Turn off to unpublish tenant."
            showLabel
            classRec
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { getAllTenants })(Tenants);
